import { createConstant } from 'redux-state-branch';
import { name } from './defs';

export const LOGIN = createConstant(name, 'LOGIN');
export const LOGOUT = createConstant(name, 'LOGOUT');
export const RESET = createConstant(name, 'RESET');
export const SET_USER = createConstant(name, 'SET_USER');
